export default __webpack_public_path__ + "static/media/notification-solid.b5c61486.svg";